import { Outlet } from 'react-router-dom';

export default function SuperAdminLayout() {
  return (
    /* ⚠️ `overflowX: 'hidden'` RETIRÉ le 11/09/2026.
     *    Il ne protégeait de rien : il COUPAIT le contenu trop large au lieu de
     *    le montrer. L'écran paraissait tenir dans la largeur, et ce qui
     *    dépassait devenait invisible — pas absent, invisible.
     * ⚠️ ET IL RENDAIT LE CONTRÔLE DE RECETTE INCAPABLE D'ÉCHOUER. Le critère
     *    « aucun défilement horizontal de la page à 390 px » était satisfait par
     *    construction, quelle que soit la mise en page : une sonde qui ne peut
     *    pas échouer ne teste rien (règle 34).
     *    ➡️ Les grilles de l'écran sont désormais intrinsèquement fluides
     *       (`minmax(min(100%, …), 1fr)`) : rien ne devrait déborder. Si quelque
     *       chose déborde encore, LE CONTRÔLE DOIT LE DIRE. */
    <div style={{
      minHeight: '100vh',
      width: '100%',
      overflowY: 'auto',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Outlet />
    </div>
  );
}
